// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const platformAdminIdentityOrganizationTree = {
  selectOrganization: "选择组织",
  organizationsLoadFailed: "组织列表加载失败",
  treeLoadFailed: "组织树加载失败",
  membersLoadFailed: "节点成员加载失败",
  treeTitle: "组织树",
  treeDescription:
    "左侧维护组织结构，点击节点切换右侧成员区，并可直接在节点行内新增下级、编辑节点或添加成员。",
  searchPlaceholder: "搜索节点名称",
  dragDisabledDuringSearch: "搜索过滤开启时已禁用拖拽，请清空搜索后再调整树结构。",
  emptyTitle: "暂无可管理组织",
  emptyDescription: "当前未查询到组织主体，请使用“创建首个组织”完成初始化。",
  createFirstOrganization: "创建首个组织",
  bootstrapCreateTitle: "创建首个组织",
  noOrganization: "请选择一个组织节点",
  organizationSummary: "组织概览",
  organizationSummaryHint: "当前组织已启用统一身份组织能力，可在这里维护结构与成员归属。",
  totalUnits: "节点总数",
  totalMemberships: "成员归属总数",
  leafUnits: "末级节点数",
  emptyLeafUnits: "空节点数",
  subtreeUnits: "当前节点覆盖节点数",
  subtreeMemberships: "当前节点覆盖归属数",
  nodeDetails: "节点详情",
  nodeWorkbench: "节点工作区",
  nodeMembers: "直属成员",
  addChild: "新增子节点",
  editNode: "编辑节点",
  addMember: "添加成员",
  deleteNode: "删除节点",
  deleteNodeTitle: "删除组织节点",
  deleteNodeDescription: "确认删除节点 {name} 吗？仅支持删除没有下级节点且没有直属成员的空节点。",
  deleteNodeConfirm: "删除节点",
  deleteNodeRootBlocked: "组织主体根节点不允许删除",
  deleteNodeChildrenBlocked: "请先清空下级节点后再删除当前节点",
  deleteNodeMembersBlocked: "请先移出直属成员后再删除当前节点",
  rootProtectedHint: "根节点来自组织主体真相，当前仅允许在其下新增子节点，不支持直接编辑或拖拽。",
  rootNode: "根节点",
  organizationHome: "组织主体",
  directMembersTag: "直属成员 {count}",
  childNodesTag: "下级节点 {count}",
  selectedNodeLabel: "节点名称",
  organizationUnitKeyLabel: "节点标识",
  parentNodeLabel: "父节点",
  childNodes: "直属子节点数",
  directMembers: "直属成员数",
  pathLabel: "当前路径：{path}",
  pathValueLabel: "节点路径",
  organizationUnitLabel: "归属节点",
  nodeSummaryRoot: "这是组织主体根节点，适合作为整体结构的起点。",
  nodeSummaryLeaf: "{name} 当前没有下级节点，可直接挂载成员。",
  nodeSummaryBranch: "{name} 下还有子节点，适合继续细分结构。",
  currentNodeEmptyHint: "当前节点还没有下级节点，也没有直属成员，可以先补充结构或挂载成员。",
  childUnits: "下级节点",
  childUnitsHint: "从这里快速查看和管理当前节点的直属下级。",
  childUnitsEmptyTitle: "当前节点还没有下级节点",
  childUnitsEmptyDescription: "可以先新增一个子节点，再继续补充成员归属。",
  childUnitLeafHint: "{name} 当前是末级节点，可直接挂载成员。",
  childUnitBranchHint: "{name} 下还有子节点，可继续向下细分结构。",
  openNode: "查看节点",
  memberManagement: "成员管理",
  directMembersHint: "只展示当前节点直接归属的成员，适合做精确挂载调整。",
  noParent: "无",
  userStatus: "用户状态",
  membershipStatus: "归属状态",
  removeMemberTitle: "移除组织成员",
  removeMemberDescription: "确认将 {user} 从 {unit} 移除吗？",
  memberRemoved: "组织成员已移除",
  memberRemoveFailed: "组织成员移除失败",
  memberCreated: "组织成员已添加",
  memberCreateFailed: "组织成员添加失败",
  nodeMoved: "组织节点已移动",
  nodeMoveFailed: "组织节点移动失败",
  nodeDeleted: "组织节点已删除",
  nodeDeleteFailed: "组织节点删除失败",
  unitCreateTitle: "新建组织节点",
  unitEditTitle: "编辑组织节点",
  nodeCreated: "组织节点已创建",
  nodeCreateFailed: "组织节点创建失败",
  nodeUpdated: "组织节点已更新",
  nodeUpdateFailed: "组织节点更新失败",
  unitNameRequired: "请输入节点名称",
  organizationNameRequired: "请输入组织名称",
  organizationKeyRequired: "请输入组织键",
  userRequired: "请选择目标用户",
  userSearchPlaceholder: "搜索用户名或昵称",
} as const;
